module.exports = __webpack_public_path__ + "e80d766fd473be134ed70894caea92b4.png";